import React from 'react'
import '../hometabs/HomeTabs.css'
import { Link } from 'react-router-dom'

const FollowingTabs = () => {
  return (
    <div className='tabs-homepage'>
        <div className='tabs-head'>
            <ul className='d-flex flex-wrap justify-content-center'>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>Chloe</span>
                </li>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>Chloe</span>
                </li>
                <li className='active-box'>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>Chloe</span>
                </li>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>Chloe</span>
                </li>
                <li className='active-box'>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>Chloe</span>
                </li>
                <li className='active-box'>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>Chloe</span>
                </li>
                <li>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>Chloe</span>
                </li>
                <li className='active-box'>
                    <span className='tabs-img'></span>
                    <span className='tabs-text'>Chloe</span>
                </li>
            </ul>
        </div>
        <div className='tabs-bottom-box'>
            <div className='tabs-box '> 
            {/* <!active-tabs-content--> */}
                <Link to="/worker" className='tabs-content d-flex flex-wrap align-items-center'>
                    <div className='left-img'></div>
                    <div className='right-box'>
                        <h5>chloelovesyou <span>9h</span></h5>
                        <p>Send me moneyyyyyyyy! </p>
                    </div>
                </Link>
            </div>
            <div className='tabs-box '>
                <Link to="/sugar-daddy"  className='tabs-content d-flex flex-wrap align-items-center'>
                    <div className='left-img'></div>
                    <div className='right-box'>
                        <h5>chloelovesyou <span>9h</span></h5>
                        <p>Send me moneyyyyyyyy! </p>
                    </div>
                </Link>
                <div className='two-img-box'>
                    <ul className='d-flex flex-wrap '>
                        <li className='img-box'></li>
                        <li className='img-box'></li>
                    </ul>
                </div>
            </div>
            <div className='tabs-box active-tabs-content'>
                 <Link to="/worker" className='tabs-content d-flex flex-wrap align-items-center'>
                    <div className='left-img'></div>
                    <div className='right-box'>
                        <h5>chloelovesyou <span>9h</span></h5>
                        <p>Send me moneyyyyyyyy! </p>
                    </div>
                </Link>
            </div>
        </div>
    </div>
  )
}

export default FollowingTabs
